import React from "react";
import AppModal from "../common/AppModal";
import { Alert } from "@mui/material";
import CreateOrUpdateProductForm from "../../forms/CreateOrUpdateProductForm";

const CreateProductModal = ({ open, onClose, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    loading={loading}
    title="Register New Product"
    width="sm"
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdateProductForm loading={loading} />
  </AppModal>
);

export default CreateProductModal;
